import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { AppState } from '@app/reducers';
import {
  CrudService,
  IApplicationResponse,
  LoggedInUserModel,
  ModulesBasedApiSuffix,
  RxjsService,
  disableFormControls, enableFormControls,
  getPDropdownData,
  prepareRequiredHttpParams,
  removeFormControlError,
  setRequiredValidator
} from '@app/shared';
import { loggedInUserData, selectStaticEagerLoadingBOCOptionsState$ } from '@modules/others';
import { BOCLinkToCustomerModel, SalesModuleApiSuffixModels } from '@modules/sales';
import { Store } from '@ngrx/store';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/api';
import { combineLatest } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
@Component({
  selector: 'app-balance-of-contract-in-lead-stage-two-popup',
  templateUrl: './balance-of-contract-in-lead-stage-two-popup.component.html',
  styleUrls: ['./balance-of-contract-in-lead-stage-two-popup.component.scss']
})

export class BalanceOfContractLeadStageTwoPopupComponent implements OnInit {
  BOCCreationForm: FormGroup;
  loggedInUserData: LoggedInUserModel;
  selectedContractDetail;
  bocOptions = [];
  contracts = [];
  data;
  bocDetails;
  multiSelectPanelStyle: any = {};
  constructor(public ref: DynamicDialogRef, public config: DynamicDialogConfig, private rxjsService: RxjsService,
    private formBuilder: FormBuilder, private store: Store<AppState>,
    private crudService: CrudService) {
    this.data = config?.data;
    this.rxjsService.setDialogOpenProperty(true);
    this.combineLatestNgrxStoreDataOne();
  }

  combineLatestNgrxStoreDataOne() {
    combineLatest([
      this.store.select(loggedInUserData), this.store.select(selectStaticEagerLoadingBOCOptionsState$)
    ]).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      this.bocOptions = response[1];
    });
  }

  ngOnInit() {
    this.createBOCCreationForm();
    this.getBOCDetails();
    this.onFormControlChanges();
  }

  onFormControlChanges() {
    let debounceTimeForSearchkeyword = 1000;
    this.BOCCreationForm.get('balanceOfContractTransferOptionId').valueChanges.subscribe((balanceOfContractTransferOptionId: string) => {
      if (!balanceOfContractTransferOptionId) return;
      // if BOC option is BOC Initiated
      if (balanceOfContractTransferOptionId == '1') {
        this.BOCCreationForm = removeFormControlError(this.BOCCreationForm, 'required', "contractId");
        this.BOCCreationForm = disableFormControls(this.BOCCreationForm, ["contractId"]);
        this.BOCCreationForm.get('contractId').setValue("");
        this.selectedContractDetail = null;
      }
      // if BOC option is Existing Contract
      else {
        this.BOCCreationForm = enableFormControls(this.BOCCreationForm, ["contractId"]);
        this.BOCCreationForm = setRequiredValidator(this.BOCCreationForm, ["contractId"]);
        if (this.bocDetails) {
          this.BOCCreationForm.get('contractId').setValue(this.bocDetails?.contractIds || '');
        }
        // this.getContractDetailByContractId();
      }
    });
    this.BOCCreationForm.get('contractId').valueChanges.pipe(debounceTime(debounceTimeForSearchkeyword),
      distinctUntilChanged()).subscribe((contractId: string) => {
        if (contractId) {
          this.selectedContractDetail = null;
          this.getContractDetailByContractId();
        };
      });
  }

  getBOCDetails() {
    this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.BOC_DETAIL, this.data?.leadId).subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response.statusCode === 200 && response.resources) {
        this.bocDetails = response.resources;
        this.rxjsService.setPopupLoaderProperty(true);
        this.BOCCreationForm.patchValue(response.resources?.customerAddress);
        this.contracts = getPDropdownData(response.resources?.contracts, 'contractRefNo', 'contractId');
        // Calculate panel height based on number of contracts
        this.calculateMultiSelectPanelHeight();
        if (response.resources?.customerAddress.isBOCCompleted && response.resources?.customerAddress?.balanceOfContractTransferOptionId == 2) {
          this.BOCCreationForm.get('contractId').setValue(response.resources?.contractIds || '');

        } else {
          this.BOCCreationForm.get('contractId').setValue('');
        }
      }
    });
  }

  calculateMultiSelectPanelHeight() {
    // Each item is approximately 38px tall (including padding)
    // Add 50px for header padding
    const itemHeight = 38;
    const headerHeight = 50;
    const maxItems = this.contracts.length;

    // Calculate height based on number of items
    // For small lists (<= 10 items), use auto height
    // For larger lists, calculate but cap at 300px
    if (maxItems <= 10) {
      // Small lists: let height be auto-adjusted
      this.multiSelectPanelStyle = {};
    } else {
      // Larger lists: set max-height but allow scrolling
      const calculatedHeight = (maxItems * itemHeight) + headerHeight;
      const maxHeight = Math.min(calculatedHeight, 300);
      this.multiSelectPanelStyle = {
        'max-height': `${maxHeight}px`
      };
    }
  }

  createBOCCreationForm() {
    let bOCLinkToCustomerModel = new BOCLinkToCustomerModel();
    this.BOCCreationForm = this.formBuilder.group({});
    Object.keys(bOCLinkToCustomerModel).forEach((key) => {
      this.BOCCreationForm.addControl(key, new FormControl(bOCLinkToCustomerModel[key]));
    });
    this.BOCCreationForm = setRequiredValidator(this.BOCCreationForm, ["balanceOfContractTransferOptionId"]);
  }

  getContractDetailByContractId() {
    let otherParams = {
      contractId: this.BOCCreationForm.get('contractId').value
    };
    //  let SalesModuleApiSuffixModels: SalesModuleApiSuffixModels;
    //  SalesModuleApiSuffixModels = SalesModuleApiSuffixModels.LEAD_BOC_CONTRACT_DETAIL;
    this.crudService.get(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.LEAD_BOC_CONTRACT_DETAIL, undefined,
      false, prepareRequiredHttpParams(otherParams)).subscribe((resp: IApplicationResponse) => {
        if (resp.isSuccess && resp.statusCode === 200 && resp.resources) {
          this.selectedContractDetail = resp.resources;
        }
        this.rxjsService.setPopupLoaderProperty(false);
      });
  }

  onSubmit() {
    if (this.BOCCreationForm.invalid) {
      return;
    }
    if (this.BOCCreationForm.value.balanceOfContractTransferOptionId == 2) {
      this.BOCCreationForm.value.contractRefNo = this.contracts?.find(c => c.contractId == this.BOCCreationForm.get('contractId').value)?.contractRefNo;
    }
    else {
      delete this.BOCCreationForm.value.contractRefNo;
    }
    this.ref.close(this.BOCCreationForm.value);
  }

  dialogClose() {
    this.ref.close(false);
  }

  ngOnDestroy() {
    this.rxjsService.setDialogOpenProperty(false);
  }
}
